import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SectionTitle from '../SectionTitle/SectionTitle';


const testimonials = [
    {
        id: '01',
        Des: "After years of chronic knee pain from arthritis, the stem cell treatment by Dr. Pereira gave me my life back. I'm now able to enjoy Florida's beautiful beaches and golf courses pain-free. The procedure was safe, professional, and the results exceeded my expectations.",
        title: 'Margaret Thompson',
        sub: "Knee Arthritis Patient - Sarasota",
    },
    {
        id: '02',
        Des: "As a former athlete dealing with shoulder injuries, I was skeptical about stem cell therapy. The medical team's expertise convinced me. Six months later, I'm back to swimming and playing tennis without pain. Truly life-changing!",
        title: 'Robert Martinez',
        sub: "Rotator Cuff Injury - Fort Myers",
    },
    {
        id: '03',
        Des: "The neuropathy in my feet was unbearable until I found Dr. Pereira's practice. His innovative approach to regenerative medicine is remarkable. The stem cell treatment has reduced my pain by 80% and I can finally sleep through the night again.",
        title: 'Patricia Williams',
        sub: "Neuropathy Patient - Naples",
    },
]




const Testimonial = (props) => {

    return (

        <section className={"" + props.tClass}>
            <div className="container-fluid px-4">
                <div className="row justify-content-left">
                    <div className="col-12">
                        <div className="section_title">
                            <h3>Real Results from Real Patients</h3>
                            <p style={{textAlign: "center"}}>
                                    Hear from patients who have experienced life-changing results through advanced regenerative medicine treatments
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row testimonial_slider" style={{ overflow: 'visible', position: 'relative' }}>
                    <Swiper
                        modules={[Autoplay, Pagination, Navigation]}
                        spaceBetween={30}
                        slidesPerView={2.3}
                        navigation={{
                            prevEl: '.swiper-button-prev',
                            nextEl: '.swiper-button-next',
                        }}
                        style={{ overflow: 'visible', padding: '15px 0 0' }}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        loop={true}
                        speed={5000}
                        allowTouchMove={true}
                        freeMode={{
                            enabled: true,
                            sticky: false,
                        }}
                        loopedSlides={3}
                        pagination={{
                            clickable: true,
                            el: '.swiper-pagination',
                        }}
                        autoHeight={false}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                                pagination: {
                                    enabled: true,
                                },
                                loop: false,
                                autoplay: false,
                                freeMode: false,
                                speed: 300,
                            },
                            768: {
                                slidesPerView: 1.5,
                                spaceBetween: 25,
                                pagination: {
                                    enabled: true,
                                },
                                loop: false,
                                autoplay: false,
                                freeMode: false,
                                speed: 300,
                            },
                            992: {
                                slidesPerView: 2.2,
                                spaceBetween: 30,
                                pagination: {
                                    enabled: false,
                                },
                            },
                            1200: {
                                slidesPerView: 2.5,
                                spaceBetween: 30,
                                pagination: {
                                    enabled: false,
                                },
                            },
                        }}
                    >
                        {testimonials.map((testitem, titem) => (
                            <SwiperSlide key={titem}>
                                <div className="testimonial_card">
                                    <div className="icon">
                                        <i className="flaticon-quote"></i>
                                    </div>
                                    <ul>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                        <li><i className="flaticon-star"></i></li>
                                    </ul>
                                    <p>{testitem.Des}</p>
                                    <div className="ath">
                                        <div className="text">
                                            <h3>{testitem.title}</h3>
                                            <span>{testitem.sub}</span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                    <div className="swiper-pagination"></div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;







